import ContainerValidation from '@/utilities/paperwork/validations/ContainerValidation'
import { ChannelStatusEnum } from '@/utilities/paperwork/enums/ChannelStatusEnum'

const TYPE_FIXING = 'fixing'
const TYPE_PARKING = 'parking'
const TYPE_CHANNEL = 'channel'

const validation = new ContainerValidation()

export default {
  setPaperwork: (state, payload) => {
    state.container = payload
  },
  setSettings: (state, payload) => {
    state.settings = payload
  },
  addEquipment: (state, payload) => {
    state.container.push({
      ...payload,
    })
  },
  removeEquipment: (state, payload) => {
    state.container = state.container.filter(item => item.id !== payload.id)
  },
  resetEquipments: state => {
    state.container = []
  },
  removeChannel: (state, payload) => {
    const index = state.container.findIndex(element => {
      return element.id === payload.equipment
    })
    if ('channels' in state.container[index]?.equipments) {
      state.container[index].equipments.channels = state.container[index]?.equipments.channels.filter(item => item.id !== payload.id)
    }
  },
  initChannel: (state, payload) => {
    const index = state.container.findIndex(element => {
      return element.equipmentRef === payload.equipmentRef
    })
    if (!('equipments' in state.container[index])) {
      return null
    }
    if (Object.keys(state.container[index].equipments).length === 0) {
      state.container[index].equipments = payload.item
    }
  },
  addChannel: (state, payload) => {
    const index = state.container.findIndex(element => {
      return element.equipmentRef === payload.equipmentRef
    })
    if (!('equipments' in state.container[index])) {
      return null
    }

    if (Object.keys(state.container[index].equipments).length > 0) {
      state.container[index].equipments.channels.push({
        ...payload.item,
        status: ChannelStatusEnum.NEW,
      })
    }
  },
  setItem: (state, payload) => {
    const index = validation.isItemAvailable(state.container, payload)
    if (index === null) {
      return
    }

    if ('type' in payload && (payload.type === TYPE_FIXING || payload.type === TYPE_PARKING)) {
      const pointIndex = state.container[index].equipments.points.findIndex(element => {
        return element.type === payload.type
      })
      state.container[index].equipments.points.splice(pointIndex, 1, payload)
    }

    if ('type' in payload && payload.type === TYPE_CHANNEL) {
      const channelIndex = state.container[index].equipments.channels.findIndex(element => {
        return element.channelRef === payload.channelRef
      })
      state.container[index].equipments.channels.splice(channelIndex, 1, payload)
    }

    validation.validateContainer(state.container)
  },
  setAnalysis: (state, payload) => {
    const index = validation.isItemAvailable(state.container, payload)
    if ('type' in payload && payload.type !== TYPE_CHANNEL) {
      return null
    }
    const channelIndex = state.container[index].equipments.channels.findIndex(element => {
      return element.channelRef === payload.channelRef
    })
    if (channelIndex === -1) {
      return null
    }
    state.container[index].equipments.channels[channelIndex].analysis = payload.analysis
  },
  setDetails: (state, payload) => {
    const index = state.container.findIndex(element => {
      return element.id === payload.id
    })
    state.container[index].equipments.details = payload
    validation.validateContainer(state.container)
  },
  setAuthority: (state, payload) => {
    const index = state.container.findIndex(element => {
      return element.equipmentRef === payload.equipmentRef
    })
    state.container[index].equipments.details.authority = payload.authority
  },
  setSpeed: (state, payload) => {
    const index = state.container.findIndex(element => {
      return element.equipmentRef === payload.equipmentRef
    })
    state.container[index].equipments.details.speed = payload.speed
  },
}
